import { stimulusApplication } from "web-ui/controllers"
import * as MorphStreamAction from "web-ui/turbo/stream-actions/morph"
import * as ConfirmationDialog from "web-ui/confirmation-dialog"
import "web-ui/turbo"

ConfirmationDialog.activate()

export { stimulusApplication, MorphStreamAction }
